<div class="field-header">
    <div class="field-header-label" [id]="labelId" woa-activatable
         [ngClass]="{
             'readOnly': readOnly(),
             'required': isRequired()
         }"
         (onActivate)="activateField($event)">{{ label() | translate: translationParams() }}</div>
    @if (link()) {
        <woa-link class="field-header-link" [link]="link()" [translationParams]="translationParams()"
                  (onActivate)="onActivateLink.emit()"></woa-link>
    }
</div>
<div class="field-body" woa-touchable woa-activatable
     [ngClass]="{
         'readOnly': readOnly(),
         'disabled': disabled(),
         'invalid': hasError() || validationMessage()
     }"
     (onActivate)="activateField($event)">
    <ng-content></ng-content>
</div>
@if (showMessages()) {
    <div class="field-messages">
        @if (showMessageSpinner()) {
            <woa-spinner class="field-messages-message"></woa-spinner>
        }
        @if (message()) {
            <div class="field-messages-message" [id]="messageId">
                {{ message() | translate: translationParams() }}
            </div>
        }
        @if (validationMessage()) {
            <div class="field-messages-message error" [id]="validationMessageId">
                {{ validationMessage() | translate: translationParams() }}
            </div>
        }
        @for (fieldValidationMessage of fieldValidationMessages(); track fieldValidationMessage) {
            <div class="field-messages-message error" id="{{errorIdPrefix}}-{{fieldValidationMessage.validationName}}">
                {{ fieldValidationMessage.message | translate: fieldValidationMessage.messageParams }}
            </div>
        }
        @for (validationMessage of serverValidationMessages(); track validationMessage; let i = $index) {
            <div class="field-messages-message error" id="{{errorIdPrefix}}-server-{{i}}">
                {{ validationMessage.messageKey | translate: validationMessage.messageParams }}
            </div>
        }
    </div>
}
